import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import translationEN from "../locales/en/translation.json";
import translationPL from "../locales/pl/translation.json";
import translationDE from "../locales/de/translation.json";

import { getLanguage } from "./consts/localStorage";

export const setAppLanguage = (language) => {
  switch (language) {
    case "Polski":
      i18n.changeLanguage("pl");
      break;
    case "Detusch":
      i18n.changeLanguage("de");
      break;
    case "English":
      i18n.changeLanguage("en");
      break;
    default:
      i18n.changeLanguage("en");
      break;
  }
  localStorage.setItem("language", language);
};

export const getAppLanguage = () => {
  return getLanguage() || "English";
};


export const getAppLanguageShortFormat = () => {
  const appLongFormatLanguge = getAppLanguage() || ""; 
  let shortFormatLanugane = ""; 
  switch (appLongFormatLanguge) {
    case "Polski":
      shortFormatLanugane = "pl";
      break;
    case "Detusch":
      shortFormatLanugane =  "de";
      break;
    case "English":
      shortFormatLanugane  = "en";
      break;
    default:
      shortFormatLanugane = "pl";
      break;
  }
  return shortFormatLanugane || "en";
};

const resources = {
  pl: {
    translation: translationPL
  },
  de: {
    translation: translationDE
  },
  en: {
    translation: translationEN
  }
};



i18n.use(initReactI18next).init({
  resources,
  lng: getAppLanguageShortFormat(),
  keySeparator: false,
  interpolation: {
    escapeValue: false
  }
});

export default i18n;
